// DEPENDENCIES
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useSubheader } from "../../../_metronic/layout";
// COMPONENTS
import { Redirect, Route, Switch } from "react-router-dom";
// CUSTOM COMPONENTS
import ClientDetailCard from "./ClientDetailCard";
import GeneralInformation from "./GeneralInformation";
import ClientLocationListingPage from "./ClientLocationListingPage";
import ClientLocationDetail from "./ClientLocationDetail";
import ClientJobListingPage from "./ClientJobLisingPage";
// SERVICES AND HELPERS
import * as clientProfileOverView from "../../../redux/ClientProfileOverViewRedux";
import * as clientService from "../../../services/management/clientService";

const ClientDetailPage = (props) => {
  const { location, updateClientProfile, clientProfile } = props
  const [clientId, setClientId] = useState(location.pathname.split('/').pop());
  const suhbeader = useSubheader();
  suhbeader.setTitle("Client Details");

  useEffect(() => {
    let url = location.pathname.split('/');
    let path = url[url.length - 2];
    let newClientId = (path == "general-information" || path == "client-detail") ? clientId : clientProfile.id;
    setClientId(newClientId);

    clientService.getClientById(newClientId).then(res => {
      updateClientProfile({
        id: res.id,
        name: res.name,
        email: res.email,
        primaryPhone: res.primaryPhone,
        location: res.address.city + ", " + res.address.state,
        imageUrl: res.logoPath,
      });
    });
  }, []);

  return (
    <div className="d-flex flex-row">
      <ClientDetailCard clientId={clientId}></ClientDetailCard>
      <div className="flex-row-fluid ml-lg-8">
        <Switch>
          <Redirect
            from="/management/client-detail/:id"
            exact={true}
            to="/management/client-detail/general-information/:id"
          />
          <Route
            path="/management/client-detail/general-information/:id"
            component={GeneralInformation}
          />
          <Route
            path="/management/client-detail/locations/:id"
            component={ClientLocationListingPage}
          />
          <Route
            path="/management/client-detail/client-location/:id"
            component={ClientLocationDetail}
          />
          <Route
            path="/management/client-detail/jobs/:id"
            component={ClientJobListingPage}
          />
        </Switch>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  clientProfile: state.clientProfile
});

export default connect(mapStateToProps, clientProfileOverView.actions)(ClientDetailPage);